module.exports = __webpack_public_path__ + "media/images/icons/or_map_pin_old-2357bd48a3a8ee7caf8f4d63f6700147.svg";